import { useFeatureFlagEnabled } from 'posthog-js/react';
import { FeatureFlag } from '../feature-flag';
import { IUseFeatureFlagIsEnabledHook } from '../feature-flag-enabled-hook.interface';

export const useFeatureFlagIsEnabled: IUseFeatureFlagIsEnabledHook = (flag: FeatureFlag) => {
  return [true, undefined].includes(useFeatureFlagEnabled(flag));
};
